import { getPathValue } from '@/form-utils/path-utils';

function getByPath(values: Record<string, unknown>, path: string) {
    return getPathValue(values, path.split('.'));
}

export function whenPathEquals(path: string, expected: unknown) {
    return (values: Record<string, unknown>) => getByPath(values, path) === expected;
}

export function whenPathIncludes(path: string, expected: unknown) {
    return (values: Record<string, unknown>) => {
        const current = getByPath(values, path);
        return Array.isArray(current) && current.includes(expected);
    };
}

export function whenAll(...predicates: Array<(values: Record<string, unknown>) => boolean>) {
    return (values: Record<string, unknown>) => predicates.every((predicate) => predicate(values));
}

export function whenAny(...predicates: Array<(values: Record<string, unknown>) => boolean>) {
    return (values: Record<string, unknown>) => predicates.some((predicate) => predicate(values));
}

export function whenPathHasValue(path: string) {
    return (values: Record<string, unknown>) => {
        const current = getByPath(values, path);

        if (Array.isArray(current)) return current.length > 0;
        if (typeof current === 'string') return current.trim().length > 0;
        return current !== null && current !== undefined;
    };
}
